import {
  getOrderProcess,
  getConfideInfo,
  saveConfide,
  saveCompleted,
  getConfideOrder,
  getConstructionPlan,
  getComplaintList,
  getComplaintInfo,
  getSchedulingInfo
} from '@/api/deliveryOnline'

const state = {
}

const mutations = {
}

const actions = {

  // ====================岳辉==========================
  getOrderProcess({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderProcess(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveCompleted({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveCompleted(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveConfide({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveConfide(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConfideOrder({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getConfideOrder(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // ====================师琼==========================
  getConfideInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getConfideInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConstructionPlan({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getConstructionPlan(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getComplaintList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getComplaintList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getComplaintInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getComplaintInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSchedulingInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getSchedulingInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
